import React, { useEffect, useMemo } from 'react';

import { faUpload } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';
import DromoImports from 'components/dromo/imports';
import LoadingSpinner from 'components/ui/loading_spinner';
import Modal from 'components/modal';

import type { Import } from 'components/dromo/types';
import EmptyState from 'shared/empty_state';

interface Props {
  importButton?: React.ReactNode;
  imports?: Import[];
  showDescription?: boolean;
  onClick?: () => void;
}

// TODO: Move polling into this component - external components shouldn't have to manage it
export default function Imports({ importButton, imports, showDescription, onClick }: Props) {
  const memoizedImports = useMemo(() => imports, [imports?.length]);

  const button = importButton ||
    <Button.Primary
      icon={faUpload}
      label="Import"
      onClick={onClick}
    />;
  let body;
  if (!memoizedImports) {
    body = <LoadingSpinner />;
  } else if (!memoizedImports.length) {
    body = (
      <EmptyState
        bodyText='Get started by clicking on the "Import" button'
        header="No Imports to Display"
        style={{ height: '400px' }}
      >
        {button}
      </EmptyState>
    );
  } else {
    body = <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="fs-large">Imports</div>
        {button}
      </div>
      <DromoImports imports={imports} showDescription={showDescription} />
    </>;
  }

  useEffect(() => {
    if (memoizedImports && memoizedImports.length === 0) {
      onClick && onClick(); // skips empty state if no imports
    }
  }, [memoizedImports]);

  return (
    <Modal.Body>
      {body}
    </Modal.Body>
  );
}
